import React from 'react';
import Card from './Card';

class Features extends React.Component{

	constructor(props) {
		super(props);
	}

	render() {
        let cards = this.props.projects.map(item => {
            return (
                <Card key={ item.uuid } project={ item } />
            );
        });

        return (
            <div className="features-wrapper">
							<div className="features-headline column-heading">
								<h3>Featured</h3>
							</div>
              { cards }
            </div>
		);
	}
};

export default Features;



// WEBPACK FOOTER //
// ./src/components/LandingPage/Features/index.js